module.exports = __webpack_public_path__ + "img/ss3.72ceee59.png";